import { isUserPatient } from "@/utils/authToken";

export const getChannelPatientReadOnlyStatus = (channel) => {
  if (isUserPatient()) {
    return channel.myMutedState === "muted";
  } else {
    return channel.otherMembers[0]?.isMuted;
  }
};

/**
 * Checks if a conversation between a patient and provider is readonly. A conversation can only be
 * readonly for patient if the provider is no longer on their care team or a presciber has marked
 * a thread as readonly for the patient.
 * @param careTeamMembers Members of the care team
 * @param channel Sendbird channel data
 * @returns {string | boolean} If conversation is readonly will return a string indicating the
 * reason from CONVERSATION_READ_ONLY_TYPES. If not readonly will return false.
 */
export const isConversationReadOnly = (careTeamMembers, channel) => {
  if (!isUserPatient() || !careTeamMembers || (channel?.otherMembers || []).length < 1) {
    return false;
  }

  const providerNoLongerOnCareTeam = !careTeamMembers
    .map((member) => member.provider_id)
    .includes(channel.otherMembers[0].userId);

  // If the provider is no longer on the care team, the conversation is readonly
  if (providerNoLongerOnCareTeam) {
    return CONVERSATION_READ_ONLY_TYPES.PROVIDER_NO_LONGER_ON_CARE_TEAM;
  }

  // Prescribers can manually mark threads as read only for patient
  if (getChannelPatientReadOnlyStatus(channel)) {
    return CONVERSATION_READ_ONLY_TYPES.PATIENT_READ_ONLY_THREAD;
  }

  return false;
};

export const CONVERSATION_READ_ONLY_TYPES = Object.freeze({
  PATIENT_READ_ONLY_THREAD: "PATIENT_READ_ONLY_THREAD",
  PROVIDER_NO_LONGER_ON_CARE_TEAM: "PROVIDER_NO_LONGER_ON_CARE_TEAM",
});
